import { useGetSpendingLimitRequest } from '@api/lendingAPI/lapiHooks';
import { Button } from '@iwoca/orion';

import styles from './DeclinedApplication.module.css';
import MainContentPending from '../../../../pageStructure/mainContentPending/MainContentPending';
import { DeclinedApplicationState } from '../../Dashboard.types';
import { useIsOverlay } from '../../hooks/useIsOverlay';

export const DeclinedApplication = ({
    application
}: {
    application?: DeclinedApplicationState;
}) => {
    const redirectUrl = application?.payLink.redirect_url || '';

    const { spendingLimitRequest, loadingSpendingLimitRequest } =
        useGetSpendingLimitRequest();

    const isOverlay = useIsOverlay();

    const handleReturnToMerchant = () => {
        if (isOverlay && !window.opener) {
            return <p>You can close this window to return to the merchant.</p>;
        }

        return (
            <Button onClick={handleClick} className={styles.redirectButton}>
                Return to merchant
            </Button>
        );
    };

    const handleClick = () => {
        if (isOverlay && window.opener) {
            window.close();
            return;
        }

        window.location.href = redirectUrl;
    };

    if (loadingSpendingLimitRequest) return <MainContentPending />;

    return (
        <div className={styles.declinedContainer}>
            <h2>
                Sorry, we can't approve your{' '}
                {spendingLimitRequest?.uuid ? (
                    <span>spending limit request</span>
                ) : (
                    <span>application</span>
                )}{' '}
                <span>today.</span>
            </h2>
            <p>
                If you’d like to speak to us about the decision or you have any
                questions, give us a ring on{' '}
                <a className={styles.link} href="tel:0203 778 0549">
                    0203 778 0549
                </a>
            </p>
            {redirectUrl && handleReturnToMerchant()}
        </div>
    );
};
